import {
  Button,
  Container,
  Link,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { t } from "i18next";
import { Box } from "@mui/system";
import Grid from "@mui/material/Grid";
import InstagramIcon from "../../assets/map.png";
import SocialMediaIcon from "../../assets/socialmedia-contactus.png";
import InstaIcon from "../../assets/instagram_aboutus.png";
import TwitterIcon from "../../assets/twitter_about_us.png";
import DribbbleIcon from "../../assets/dribbble_contact_us.png";
import FacebookIcon from "../../assets/fb_aboutus.png";
import LocationIcon from "../../assets/location_contact_us.png";
import EmailIcon from "../../assets/email_contact_us.png";
import PhoneIcon from "../../assets/phone_contact_us.png";
import "./ContactUs.css";
import { useEffect } from "react";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "تماس با ما";
  }, []);
  return (
    <Box sx={{ bgcolor: "background.default", py: 4 }}>
      <Container>
        <Stack
          direction={"row"}
          mb={2}
          spacing={4}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <div
            style={{
              background:
                "linear-gradient(90deg, #8E2DE2 0.33%, rgba(74, 0, 224, 0.51) 100.65%)",
              width: "80px",
              height: "1px",
            }}
          ></div>
          <Typography
            variant="h4"
            sx={{ textAlign: "center", color: "text.primary" }}
          >
            {t("contact_us")}
          </Typography>
          <div
            style={{
              background:
                "linear-gradient(90deg, #8E2DE2 0.33%, rgba(74, 0, 224, 0.51) 100.65%)",
              transform: "rotate(-180deg)",
              width: "80px",
              height: "1px",
            }}
          ></div>
        </Stack>
        <Typography
          variant="subtitle1"
          component="p"
          sx={{ textAlign: "center", color: "text.secondary" }}
        >
          اگر جواب سوالات خود را پیدا نکردید یا یا نیاز به پشتیبانی دارید
          میتوانید با استفاده از فرم زیر یا راه های ارتباطی با ما در ارتباط
          باشید
        </Typography>
        <Grid
          container
          sx={{
            bgcolor: "#37306B",
            pr: { xs: 0, md: 2 },
            borderRadius: "15px",
            mt: 4,
            mb: 2,
          }}
        >
          <Grid item xs={12} md={6}>
            <Box
              className="outer_section_shape"
              sx={{
                pl: 3,
                py: { xs: 4, md: 10 },
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h4"
                component="p"
                sx={{ textAlign: "start", color: "text.primary", my: 2 }}
              >
                {t("ways_to_us")}
              </Typography>
              <Typography
                variant="h6"
                component="p"
                sx={{
                  textAlign: "start",
                  color: "text.secondary",
                  my: 4,
                  pr: 10,
                }}
              >
                شما می توانید همه روزه از ساعت ۸ الی ۱۶ با تیم پشتیبانی در
                ارتباط باشید
              </Typography>
              <Stack spacing={2.5} my={3.5}>
                <Stack spacing={1.25} direction={"row"}>
                  <Box>
                    <img src={PhoneIcon} alt="icon" width="auto" />
                  </Box>
                  <Typography
                    variant="subtitle1"
                    component="p"
                    sx={{ textAlign: "center", color: "text.primary" }}
                  >
                    0912334567
                  </Typography>
                </Stack>
                <Stack spacing={1.25} direction={"row"}>
                  <Box>
                    <img src={EmailIcon} alt="icon" width="auto" />
                  </Box>
                  <Typography
                    variant="subtitle1"
                    component="p"
                    sx={{ textAlign: "center", color: "text.primary" }}
                  >
                    info[AT]parsianbit[DOT]com
                  </Typography>
                </Stack>
                <Stack spacing={1.25} direction={"row"}>
                  <Box>
                    <img src={LocationIcon} alt="icon" width="auto" />
                  </Box>
                  <Typography
                    variant="subtitle1"
                    component="p"
                    sx={{ textAlign: "start", color: "text.primary" }}
                  >
                    تهران
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                direction={"row"}
                spacing={4}
                mt={4}
                justifyContent={"start"}
                alignItems={"center"}
              >
                <Box>
                  <img src={InstaIcon} alt="icon" width="auto" />
                </Box>
                <Box>
                  <img src={DribbbleIcon} alt="icon" width="auto" />
                </Box>
                <Box>
                  <img src={TwitterIcon} alt="icon" width="auto" />
                </Box>
                <Box>
                  <img src={FacebookIcon} alt="icon" width="auto" />
                </Box>
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} sx={{ py: 2, px: { xs: 1.5, md: 2 } }}>
            <Typography
              variant="h4"
              component="p"
              sx={{ textAlign: "start", color: "text.primary" }}
            >
              {t("send_message")}
            </Typography>
            <Box
              sx={{
                bgcolor: "inherit",
                display: "flex",
                justifyContent: "center",
                borderRadius: "10px",
                mt: 2,
              }}
            >
              <Box sx={{ width: { xs: "100%", sm: 600 } }}>
                <Stack
                  sx={{ mt: 2 }}
                  spacing={0.5}
                  direction={{ xs: "column" }}
                >
                  <Typography
                    variant="h6"
                    component="p"
                    sx={{ color: "text.secondary", textAlign: "start" }}
                  >
                    {t("name")}
                  </Typography>
                  <TextField
                    sx={{
                      bgcolor: "#1B1C31",
                      borderRadius: "15px",
                      "& fieldset": { border: "none" },
                      width: "100%",
                    }}
                    id="outlined-basic"
                    label={`${t("name")}`}
                    margin="dense"
                  />
                </Stack>
                <Stack
                  sx={{ mt: 2 }}
                  spacing={0.5}
                  direction={{ xs: "column" }}
                >
                  <Typography
                    variant="h6"
                    component="p"
                    sx={{ color: "text.secondary", textAlign: "start" }}
                  >
                    {t("title_of_message")}
                  </Typography>
                  <TextField
                    sx={{
                      bgcolor: "#1B1C31",
                      borderRadius: "15px",
                      "& fieldset": { border: "none" },
                      width: "100%",
                    }}
                    id="outlined-basic-2"
                    label={`${t("title_of_message_par")}`}
                    variant="outlined"
                    margin="dense"
                  />
                </Stack>
                <Stack
                  sx={{ mt: 2 }}
                  spacing={0.5}
                  direction={{ xs: "column" }}
                >
                  <Typography
                    variant="h6"
                    component="p"
                    sx={{ color: "text.secondary", textAlign: "start" }}
                  >
                    {t("email")}
                  </Typography>
                  <TextField
                    sx={{
                      bgcolor: "#1B1C31",
                      borderRadius: "15px",
                      "& fieldset": { border: "none" },
                      width: "100%",
                    }}
                    id="outlined-basic-2"
                    label={`${t("enter_your_email")}`}
                    variant="outlined"
                    margin="dense"
                  />
                </Stack>
                <Stack sx={{ mt: 2 }} spacing={0.5}>
                  <Typography
                    variant="h6"
                    component="p"
                    sx={{ color: "text.secondary", textAlign: "start" }}
                  >
                    {t("message_subject")}
                  </Typography>
                  <TextField
                    sx={{
                      bgcolor: "#1B1C31",
                      borderRadius: "15px",
                      pb: 6,
                      "& fieldset": { border: "none" },
                      width: "100%",
                    }}
                    label={`${t("enter_your_message")}`}
                    id="fullWidth"
                  />
                </Stack>
                <Stack sx={{ mt: 4 }} alignItems="end" justifyContent="end">
                  <Button
                    variant="contained"
                    sx={{
                      width: "10rem",
                      height: "2.5rem",
                      px: 2,
                      py: 2.5,
                      borderRadius: "50px",
                      background: "#FF3DFF",
                      mt: { xs: 2, sm: 0 },
                    }}
                  >
                    {t("send")}
                  </Button>
                </Stack>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactUs;
